module.exports = __webpack_public_path__ + "static/joc_07-e2961b1f50fc1a0620f7f4dc886ac4fe.jpg";